import MobileSliderPagesWrapper from "../components/MobileSliderPagesWrapper.jsx";
import MobileSliderPagesHeader from "../components/MobileSliderPagesHeader.jsx";
import { useLocation } from "react-router";
import React from "react";
import MobileAssetInfoHeader from "../../MobileAssetInfo/MobileAssetInfoHeader.jsx";
import MobileAssetInfo from "../../MobileAssetInfo/MobileAssetInfo.jsx";
import { MobileSliderPagesContentStyled } from "../components/styled/MobileSliderPagesStyled.js";

function SlideMobileAssetInfo() {
    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);
    const symbol = searchParams.get('symbol');

    return <MobileSliderPagesWrapper backgroundColor="var(--color-base)">
        <MobileSliderPagesHeader goBack>
            <MobileAssetInfoHeader symbol={symbol}/>
        </MobileSliderPagesHeader>

        <MobileSliderPagesContentStyled>
            <MobileAssetInfo symbol={symbol}/>
        </MobileSliderPagesContentStyled>

    </MobileSliderPagesWrapper>
}

export default SlideMobileAssetInfo;
